module.exports = __webpack_public_path__ + "img/index-ydn.2c388a04.png";